import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fromStore } from '../../../selectors';
import cn from 'classnames';
import Loader from '../../../components/utils/Loader';
import { isEmpty } from 'lodash';
import { ItemRow } from './ItemRow';
import { TableHeader } from './TableHeader';
import { useDispatch } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { styles } from '../styles';
import { fetchSettings } from '../../../action/app';

export function GoodsList() {
    const dispatch = useDispatch();
    const loaderList = useSelector(fromStore.loaderGoodsSelector);
    const loaderImport = useSelector(state => state.loaders.receipesImport);
    const goods = useSelector(fromStore.selectedCategoryGoods);
    const settings = useSelector(state => state.settings.init);
    const loadinSettings = useSelector(state => state.loaders.settings)
    const loading = loaderList || loaderImport || loadinSettings;

    useEffect(() => ReactTooltip.rebuild(), [goods, loaderList]);

    useEffect(() => {
        isEmpty(settings) && dispatch(fetchSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const filteredGoods = goods.filter((item) => !item.isGroup);

    return (
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }}>
            <div className="kt-portlet kt-portlet--mobile">
                <div className="kt-portlet__body kt-portlet__body--fit">
                    <div
                        style={{ position: 'relative', marginBottom: 0 }}
                        className={
                            cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded', {
                                'kt-datatable--error': isEmpty(goods)
                            })
                        }>
                        {loading && <div style={styles.tableLoading}><Loader text='Загружаю товары'/></div>}
                        <table className="kt-datatable__table" style={ window.innerWidth > 730 ? { minHeight: '700px' } : {}}>
                           {window.innerWidth > 730 && <TableHeader/>}
                                <tbody className="kt-datatable__body">
                                    {
                                        loading
                                            ? null
                                            : isEmpty(filteredGoods)
                                                ? <tr><td colSpan={8}><span className="kt-datatable--error">Товары не найдены</span></td></tr>
                                                : filteredGoods.map((item) => <ItemRow key={item.id} item={item}/>)
                                    }
                                </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ReactTooltip
                effect="solid"
                type="dark"
                place="top"
            />
        </div>
    );
}